import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxLineClampModule } from 'ngx-line-clamp';
import { LineTruncationDirective, LineTruncationLibModule } from 'ngx-line-truncation';
// components
import { HeaderComponent } from './components/header/header.component';
import { HeaderSmallComponent } from './components/header-small/header-small.component';
import { CheckoutBtnComponent } from './components/checkout-btn/checkout-btn.component';
import { NotificationModalComponent } from './components/notification-modal/notification-modal.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SmartHeaderDirective } from './directives/smart-header.directive';
import { OrderStatusComponent } from './components/order-status/order-status.component';
import { CartComponent } from './components/cart/cart.component';
import { CartItemComponent } from './components/cart-item/cart-item.component';
import { ProductModalComponent } from './components/product-modal/product-modal.component';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { PickUpDateTimeComponent } from '../pages/checkout/components/pick-up-date-time/pick-up-date-time.component';
import { TipRadioGroupComponent } from '../pages/checkout/components/tip-radio-group/tip-radio-group.component';
import { ScheduledPickupTimepickerComponent } from '../pages/checkout/components/scheduled-pickup-timepicker/scheduled-pickup-timepicker.component';
import { TippingComponent } from '../pages/restaurant/components/tipping/tipping.component';
import { CustomTippingComponent } from '../pages/restaurant/components/custom-tipping/custom-tipping.component';
import { OrdersStatusComponent } from './components/orders-status/orders-status.component';
import { OrderListComponent } from './components/order-list/order-list.component';
// services
import { RouteService } from '../core/services/route.service';
import { TabOrderStatusComponent } from './components/tab-order-status/tab-order-status.component';
import { TabOrdersStatusComponent } from './components/tab-orders-status/tab-orders-status.component';
import { HeaderTextPopoverComponent } from './components/header-text-popover/header-text-popover.component';
import { AgeGateModalComponent } from '../pages/restaurant/components/age-gate-modal/age-gate-modal.component';
import { LocationChangeModalComponent } from '../pages/restaurant/components/location-change-modal/location-change-modal.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatSliderModule } from '@angular/material/slider';
import { LocationListComponent } from './components/location-list/location-list.component';
import { TabModalComponent } from '../pages/restaurant/components/tab-modal/tab-modal.component';
import { RestaurantClosedModalComponent } from '../pages/restaurant/components/restaurant-closed-modal/restaurant-closed-modal.component';
import { LoyaltyBannerComponent } from './components/loyalty-banner/loyalty-banner.component';
import { MultiselectComponent } from '../pages/checkout/components/multiselect/multiselect.component';
import { BillingAddressComponent } from '../pages/checkout/components/billing-address/billing-address.component';
import { VerifyPhoneNumberComponent } from './components/verify-phone-number/verify-phone-number.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SmsCodeComponent } from './components/sms-code/sms-code.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CookieService } from 'ngx-cookie-service';
import { CurrentOrdersService } from '../core/services/current-orders.service';
import { ItemService } from '../core/services/item.service';
import {TableRedirectService} from '../core/services/TableRedirectService';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatExpansionModule} from "@angular/material/expansion";
import {
  SharedOrdersModalComponent
} from "../pages/restaurant/components/shared-orders-modal/shared-orders-modal.component";
import { QRCodeModule } from 'angularx-qrcode';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxBarcodeModule } from 'ngx-barcode';
import { FooterCfComponent } from './components/footer-cf/footer-cf.component';
import { SignInModalComponent } from './components/sign-in-modal/sign-in-modal.component';
import { HeaderMenuComponent } from './components/header-menu/header-menu.component';
import { SafeHtmlPipe } from '../core/pipes/safe-html.pipe';
import { SpriteIconPipe } from '../core/pipes/sprite-icon.pipe';
import {GoogleMapsModule} from '@angular/google-maps';
import {
  ThrottlingConfirmationComponent
} from './components/product-modal/throttling-confirmation/throttling-confirmation.component';
import {OrderOnlyModalComponent} from './components/order-only-modal/order-only-modal.component';
import { DietaryModalComponent } from './components/dietary-modal/dietary-modal.component';
import { ShoppingBagIconComponent } from './components/shopping-bag-icon/shopping-bag-icon.component';
import { ShiftsFilterModalComponent } from './components/shifts-filter-modal/shifts-filter-modal.component';
import { PromocardModalComponent } from './components/promocard-modal/promocard-modal.component';
import { GiftCardTileComponent } from './components/gift-card-tile/gift-card-tile.component';
import { CategoriesModalComponent } from '../pages/restaurant/components/categories-modal/categories-modal.component';
import { PopupMarketingComponent } from './components/popup-marketing/popup-marketing.component';
import { TelPasteFixDirective } from './directives/tel-paste-fix.directive';
import { ScheduleTimeModalComponent } from '../pages/restaurant/components/schedule-time-modal/schedule-time-modal.component';
import {
  ContactInformationModalComponent
} from './components/header/contact-information-modal/contact-information-modal.component';

import { RestaurantProviderDirective } from '../core/directive/restaurant-provider.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    IonicModule,
    // For TippingComponent
    CurrencyMaskModule,
    LineTruncationLibModule,
    NgxLineClampModule,
    LazyLoadImageModule,
    MatSliderModule,
    NgOtpInputModule,
    TextMaskModule,
    NgxIntlTelInputModule,
    NgOtpInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatExpansionModule,
    QRCodeModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    NgxBarcodeModule,
    GoogleMapsModule
  ],
  declarations: [
    // Lives here, not in CheckoutPageModule: the shared modals and the
    // order-complete page need it too, and borrowing it by importing
    // CheckoutPageModule into SharedModule was a circular import --
    // CheckoutPageModule already imports SharedModule -- which broke the
    // build with 'Maximum call stack size exceeded'.
    RestaurantProviderDirective,
    HeaderComponent,
    HeaderSmallComponent,
    CheckoutBtnComponent,
    NotificationModalComponent,
    // Temporary fix
    PickUpDateTimeComponent,
    TipRadioGroupComponent,
    ScheduledPickupTimepickerComponent,
    TippingComponent,
    CustomTippingComponent,
    SpinnerComponent,
    SmartHeaderDirective,
    OrderStatusComponent,
    CartComponent,
    ProductModalComponent,
    ProductDetailsComponent,
    CartItemComponent,
    OrdersStatusComponent,
    HeaderTextPopoverComponent,
    OrdersStatusComponent,
    TabOrderStatusComponent,
    TabOrdersStatusComponent,
    AgeGateModalComponent,
    LocationChangeModalComponent,
    RestaurantClosedModalComponent,
    TabModalComponent,
    LocationListComponent,
    LoyaltyBannerComponent,
    MultiselectComponent,
    BillingAddressComponent,
    VerifyPhoneNumberComponent,
    SideMenuComponent,
    SmsCodeComponent,
    SharedOrdersModalComponent,
    FooterCfComponent,
    OrderListComponent,
    SignInModalComponent,
    HeaderMenuComponent,
    SafeHtmlPipe,
    SpriteIconPipe,
    ThrottlingConfirmationComponent,
    OrderOnlyModalComponent,
    DietaryModalComponent,
    ShoppingBagIconComponent,
    ShiftsFilterModalComponent,
    PromocardModalComponent,
    GiftCardTileComponent,
    CategoriesModalComponent,
    PopupMarketingComponent,
    TelPasteFixDirective,
    ScheduleTimeModalComponent,
    ContactInformationModalComponent
    ],
  exports: [
    RestaurantProviderDirective,
    HeaderComponent,
    HeaderSmallComponent,
    CheckoutBtnComponent,
    NotificationModalComponent,
    SpinnerComponent,
    SmartHeaderDirective,
    OrderStatusComponent,
    CartItemComponent,
    ProductModalComponent,
    ProductDetailsComponent,
    // Temporary fix
    PickUpDateTimeComponent,
    TipRadioGroupComponent,
    ScheduledPickupTimepickerComponent,
    TippingComponent,
    CustomTippingComponent,
    TabOrderStatusComponent,
    AgeGateModalComponent,
    LocationChangeModalComponent,
    TabModalComponent,
    RestaurantClosedModalComponent,
    LoyaltyBannerComponent,
    MultiselectComponent,
    BillingAddressComponent,
    LineTruncationDirective,
    VerifyPhoneNumberComponent,
    SideMenuComponent,
    SmsCodeComponent,
    FooterCfComponent,
    OrderListComponent,
    SignInModalComponent,
    HeaderMenuComponent,
    SafeHtmlPipe,
    SpriteIconPipe,
    OrderOnlyModalComponent,
    ShoppingBagIconComponent,
    ShiftsFilterModalComponent,
    PromocardModalComponent,
    GiftCardTileComponent,
    CategoriesModalComponent,
    PopupMarketingComponent,
    TelPasteFixDirective,
    ScheduleTimeModalComponent,
    ContactInformationModalComponent
  ],
  providers: [
    RouteService,
    CookieService,
    CurrentOrdersService,
    ItemService,
    TableRedirectService
  ],
})
export class SharedModule {}
